import { TOGGLE_LOCATION_FILTER_MENU } from './constants';

export function toggleLocationFilterMenu(value) {
  return {
    type: TOGGLE_LOCATION_FILTER_MENU,
    value,
  };
}
